import { render, staticRenderFns } from "./SVO.vue?vue&type=template&id=51a243b2&"
import script from "./SVO.vue?vue&type=script&lang=js&"
export * from "./SVO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports